import { App } from "./App";
window.app = new App();
